import { getCurrentParams } from "./getCurrentParams"

export function getCurrentPage() {
    const defaultPage = 1
    const params = getCurrentParams()
    if (!params) return defaultPage
    if ("page" in params) {
        return params.page
    }
    return defaultPage
}
